import { PanelRadioGroup, PanelRadioGroupOptionType } from '@/components/form/fields/PanelRadioGroup/PanelRadioGroup';
import { ChangeEvent, ReactNode } from 'react';
import { useField } from 'formik';
import { getFieldError } from '@/helpers/formHelpers/formHelpers';
import { ResponseErrorType } from '@/types/sharedTypes';

type FormikPanelRadioGroupType = {
  name: string;
  label: ReactNode;
  options: PanelRadioGroupOptionType[];
  disabled?: boolean;
  apiError?: ResponseErrorType;
};

export const FormikPanelRadioGroup = ({ name, label, options, disabled, apiError }: FormikPanelRadioGroupType) => {
  const [field, meta, { setValue }] = useField(name);
  const { apiError: apiErrorMessage } = getFieldError(name, meta, apiError);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value);
  };

  return (
    <PanelRadioGroup
      {...field}
      label={label}
      options={options}
      disabled={disabled}
      onChange={handleChange}
      apiError={apiErrorMessage}
    />
  );
};
